module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_LT-51113b486a1b7187d7db8cc3c9d78b38.svg";